import { render, staticRenderFns } from "./draganddrop.vue?vue&type=template&id=038168cc&scoped=true&"
import script from "./draganddrop.vue?vue&type=script&lang=js&"
export * from "./draganddrop.vue?vue&type=script&lang=js&"
import style0 from "./draganddrop.vue?vue&type=style&index=0&id=038168cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038168cc",
  null
  
)

export default component.exports